module.exports = __webpack_public_path__ + "static/img/company1.3cbb27d8.svg";